import type { PageNavigation } from 'navigation/types';

import * as urls from '../urls';

export const INVESTORS_NAVIGATION: PageNavigation = {
  pageUrl: urls.getInvestorsUrl(),
  currentLink: { text: 'Investor relations', href: urls.getInvestorsUrl() },
  links: [
    {
      text: 'Financial Information',
      href: urls.getInvestorsReportListUrl('annual'),
      matchHref: urls.getInvestorsReportUrl(),
    },
    {
      text: 'Announcements',
      href: urls.getFinancialAnnouncementsUrl(),
    },
    {
      text: 'News and Updates',
      href: urls.getFinancialNewsUrl(),
    },
  ],
};
